import { render, staticRenderFns } from "./MfrMenu.vue?vue&type=template&id=09e9a59f&"
import script from "./MfrMenu.vue?vue&type=script&lang=ts&"
export * from "./MfrMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports